<template>
  <div class="account-settings-root" :class="{ readonly: $firebase.readOnly }">
    <p>---</p>
    <p>Account Settings:</p>
    <SettingProxyWidget :setting="accountSettings.urlFilterSetting" />
    <SettingProxyWidget :setting="accountSettings.displayCurrency" />
    <p>---</p>
    <ActivityButton :activity="isSaving" :disabled="!accountSettings.dirty" @click="Save">Save</ActivityButton>
    <ActivityButton :disabled="!accountSettings.dirty" @click="Revert">Revert</ActivityButton>
  </div>
</template>

<script>
import { AccountSettings } from "../../code/classes/AccountSettings";
import ActivityButton from "./ActivityButton.vue";
import SettingProxyWidget from "./SettingProxyWidget.vue";

export default {
  components: {
    ActivityButton,
    SettingProxyWidget,
  },
  props: {
    accountSettings: { type: AccountSettings },
  },
  data() {
    return {
      isSaving: false,
    };
  },
  methods: {
    async Save() {
      if (this.isSaving) return;
      this.isSaving = true;

      this.accountSettings
        .Save()
        .then(() => {
          this.isSaving = false;
        })
        .catch(() => {
          this.isSaving = false;
        });
    },
    Revert() {
      this.accountSettings.Revert();
    },
  },
};
</script>

<style scoped lang="scss">
.readonly {
  opacity: 0.5;
  pointer-events: none;
  user-select: none;
}
</style>
